__webpack_require__.p = "/Web_dev_training/";